import {customAxiosBE} from "../config";
import moment from "moment";
import {parsePaginationParams} from "../../utils/other";

export async function getCashierLiquidationPreviewAPI(payload) {
    const { filter, params } = payload;

    let cashier = filter.cashier;
    const parsedParams = parsePaginationParams(params);
    return customAxiosBE.post(`/liquidation/search?${parsedParams}`, { cashier})
}

export async function getPrevLiquidationPreviewAPI(payload) {
    const { filter, params } = payload;

    let dateFrom = filter.dateFrom ? moment(filter.dateFrom).format("YYYY-MM-DD") : null;

    let dateTo = filter.dateTo ? moment(filter.dateTo).format("YYYY-MM-DD") : null;

    let cashier = filter.cashier;

    if (dateFrom) {
        dateFrom = moment(dateFrom).format("YYYY-MM-DD HH:mm:ss");
    }
    if (dateTo) {
        dateTo = moment(dateTo).format("YYYY-MM-DD HH:mm:ss");
    }
    const parsedParams = parsePaginationParams(params);
    return customAxiosBE.post(`/liquidation/history/search`, { cashier, dateFrom, dateTo})
}

export async function insertCashierLiquidationAPI(data) {
    const {cashier, loggedUser} = data
    if(!cashier || !loggedUser){
        return
    }
    return customAxiosBE.post(`/liquidation`, data)
}

export async function getDailyLiquidationPreview(data) {
    const {cashier, loggedUser} = data
    if(!cashier || !loggedUser){
        return
    }
    return customAxiosBE.post(`/liquidation/daily-preview`, data)
}
